import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCursorRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M4.96 1.72A.6.6 0 0 0 4 2.2v10a.598.598 0 0 0 1.08.36l2.417-3.225 2.366 4.732a.597.597 0 0 0 .805.268.597.597 0 0 0 .267-.805L8.568 8.797h4.03a.598.598 0 0 0 .36-1.08zm.24 8.68v-7l5.6 4.2H7.6a.6.6 0 0 0-.48.24z" })
});
export default SvgCursorRegularIcon;
